/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Event_Recipients_Remove_Aria_LabelInputs */

const en_event_recipients_remove_aria_label = /** @type {(inputs: Event_Recipients_Remove_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name}`)
};

const fr_event_recipients_remove_aria_label = /** @type {(inputs: Event_Recipients_Remove_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retirer ${i?.name}`)
};

const de_event_recipients_remove_aria_label = /** @type {(inputs: Event_Recipients_Remove_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entferne ${i?.name}`)
};

const it_event_recipients_remove_aria_label = /** @type {(inputs: Event_Recipients_Remove_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rimuovi ${i?.name}`)
};

const ru_event_recipients_remove_aria_label = /** @type {(inputs: Event_Recipients_Remove_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Удалить ${i?.name}`)
};

const es_event_recipients_remove_aria_label = /** @type {(inputs: Event_Recipients_Remove_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eliminar ${i?.name}`)
};

const zh_cn2_event_recipients_remove_aria_label = /** @type {(inputs: Event_Recipients_Remove_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`移除${i?.name}`)
};

const ja_event_recipients_remove_aria_label = /** @type {(inputs: Event_Recipients_Remove_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を削除`)
};

const hi_event_recipients_remove_aria_label = /** @type {(inputs: Event_Recipients_Remove_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} को हटाएँ`)
};

const pt_pt2_event_recipients_remove_aria_label = /** @type {(inputs: Event_Recipients_Remove_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Remove {name}" |
*
* @param {Event_Recipients_Remove_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_recipients_remove_aria_label = /** @type {((inputs: Event_Recipients_Remove_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Recipients_Remove_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_recipients_remove_aria_label(inputs)
	if (locale === "de") return de_event_recipients_remove_aria_label(inputs)
	if (locale === "it") return it_event_recipients_remove_aria_label(inputs)
	if (locale === "ru") return ru_event_recipients_remove_aria_label(inputs)
	if (locale === "es") return es_event_recipients_remove_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_recipients_remove_aria_label(inputs)
	if (locale === "ja") return ja_event_recipients_remove_aria_label(inputs)
	if (locale === "hi") return hi_event_recipients_remove_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_recipients_remove_aria_label(inputs)
	return en_event_recipients_remove_aria_label(inputs)
});